import { generateApiPath } from "@routes/generatePath";

const pathBase = `/medical-service-provider/reports/doctors/`;

export const medicalServiceProviderDoctors = {
  get: () => generateApiPath(pathBase),
};
